<script lang="ts">
  import type { TransactionPanelProps } from "./types";
  import PdfDocumentView from "./PDFDocumentView.svelte";
  import BaseTransactionPanel from "./BaseTransactionPanel.svelte";

  export let props: TransactionPanelProps;

  let documentZoomed: boolean;
</script>

<BaseTransactionPanel {...props}>
  <div slot="top">
    {#if props.transaction.document_url}
      <div class="invoice-image" class:zoom={documentZoomed}>
        <PdfDocumentView
          url={props.transaction.document_url}
          filename={props.transaction.reference}
          showDownload={true}
          bind:zoomed={documentZoomed}
        />
      </div>
    {/if}
  </div>
</BaseTransactionPanel>

<style>
  .invoice-image {
    position: relative;
    justify-content: center;
    height: 320px;
    width: 100%;
    overflow: scroll;
    background-color: var(--rk-neutral-0);
    border: solid 1px var(--rk-divider-0);
    border-radius: 8px;
    margin-top: 4px;
    margin-bottom: 8px;
    transition: all 0.3s ease-in-out;
  }

  .zoom {
    height: 694px;
  }
</style>
